import { Component, OnInit, Input, ComponentFactoryResolver, ViewChild } from '@angular/core';
import { FormPageConfig } from '../../../models/form-page-config';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DynamicWidgetDirective } from 'sce-ui-lib';
import { DynamicWidget } from '../dynamic-widget';

@Component({
  selector: 'lfwms-dynamic-widget-holder',
  templateUrl: './dynamic-widget-holder.component.html',
  styleUrls: ['./dynamic-widget-holder.component.css']
})
export class DynamicWidgetHolderComponent implements OnInit {

  @Input() public pageConfig: FormPageConfig;
  @Input() public widgetConfig: LFDynamicWidgetConfig;

  @ViewChild(DynamicWidgetDirective) dynamicWidget: DynamicWidgetDirective;

  private componentFactoryResolver: ComponentFactoryResolver;

  constructor(private coreServiceRegistry: CoreServiceRegistry) {
    this.componentFactoryResolver = coreServiceRegistry.componentFactoryResolver;
  }

  public ngOnInit() {
    this.loadComponentDynamically();
  }

  private loadComponentDynamically() {
    const dynamicWidgetComponent = this.pageConfig.columnGroupComponentConfig[this.widgetConfig.id];
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dynamicWidgetComponent);

    const viewContainerRef = this.dynamicWidget.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<DynamicWidget>componentRef.instance).pageConfig = this.pageConfig;
    (<DynamicWidget>componentRef.instance).widgetConfig = this.widgetConfig;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/dynamic-widget-holder/dynamic-widget-holder.component.ts